
<v-dialog
    v-if          = "document"
    v-model       = "show"
    max-width     = "630"
    class         = "white"
    :scrollable   = "false"
    content-class = "dialog-border"
    persistent
    no-click-animation
>
    <div class="primary--text white pt-2 pb-1 v-flex" >
        <v-select
            v-if           = "stamps.items"
            :disabled      = "loading"
            :items         = "stamps.items"
            v-model        = "stamps.selected"
            item-value     = "id"
            item-text      = "name"
            :return-object = true
            class          ="pt-2 pb-2 ml-4 mr-0"
            style          ="max-width: 315px"
            @change        = "onStamp"
            solo
            dense
            hide-details
        >
            <template v-slot:prepend-inner>
                <v-icon size="20" color="primary">mdi-stamper</v-icon>
            </template>
        </v-select>

        <div class="ml-4" style="margin-top: 10px;">
            <c-toolbar-button
                icon     = "mdi-minus-circle"
                :color   = "stampSize > 0 ? 'primary' : 'dialog-button-inactive'"
                size     = "26"
                :tooltip = "$t('stamp.smaller')"
                @click   = "onMinus"
            />
        </div>

        <div class="stamp-size primary white--text">
            {{ stampSizeText }}
        </div>

        <div class="ml-1" style="margin-top: 10px;">
            <c-toolbar-button
                icon     = "mdi-plus-circle"
                :color   = "stampSize < 3 ? 'primary' : 'dialog-button-inactive'"
                size     = "26"
                :tooltip = "$t('stamp.greater')"
                @click   = "onPlus"
            />
        </div>


        <v-spacer />
        <div class="mt-2 mr-3">
            <c-toolbar-button
                icon="mdi-close"
                size="30"
                color="red"
                @click = "onCancel"
            />
        </div>
    </div>

    <div class="white" v-if = "loading">
        <v-progress-linear
            color  = "primary"
            height = "4"
            indeterminate
        />
    </div>

    <div class="white" style="height: 4px;" v-if = "!loading">
    </div>

    <v-card class="white" active-class="white" style="border-top-right-radius: 0; border-top-left-radius: 0; min-height: 847px;">
        <div class="text-center pt-0" >
            <div>
                <inc-drag-stamp
                    v-show="!loading"
                     ref      = "stamp"
                    :image    = "stampImage"
                    :width    = "width"
                    @position = "onPosition"
                />


                    <img
                        v-if   = "image"
                        ref    = "image"
                        :src   =  "image"
                        alt    = ""
                        height = "840px"
                    />
            </div>
        </div>

        <v-divider class="pt-2" />
        <v-card-actions class="pt-0 pb-2">
            <v-pagination
                :disabled = "loading"
                v-model="page"
                :length="pages"
                :total-visible = "4"
                circle
                @input = "onPage"
            ></v-pagination>

            <v-spacer></v-spacer>

            <v-btn
                text
                @click = "onPerform"
                color  = "white"
                class = "dialog-button mr-0 primary"
            >
                {{ $t('inc.stamper.stamp') }}
            </v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
